export default __webpack_public_path__ + "static/media/location-pin-parking.943662fc.png";